/* eslint-disable @nx/enforce-module-boundaries */
import { Component, ElementRef, ViewChild, inject } from '@angular/core';
import {
  NonNullableFormBuilder,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { LoaderIndicatorDirective, LoaderService, NotificationService } from '@t-llevo/common-ui';
import { DialogHeaderComponent } from 'admin-drivers/src/app/common/dialog/components/dialog-header/dialog-header.component';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { toSignal } from '@angular/core/rxjs-interop';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { VersionControlDataService } from '../../services/version-control-data/version-control-data.service';
import { finalize } from 'rxjs';
import { HttpErrorResponse } from '@angular/common/http';
import { VersionControlService } from 'admin-drivers/src/app/api/services/version-control.service';

@Component({
  selector: 't-llevo-version-control-add',
  standalone: true,
  imports: [
    ReactiveFormsModule,
    MatDialogModule,
    MatButtonModule,
    LoaderIndicatorDirective,
    DialogHeaderComponent,
    MatFormFieldModule,
    MatInputModule,
    MatCheckboxModule,
  ],
  providers: [LoaderService, VersionControlDataService],
  templateUrl: './version-control-add.component.html',
  styles: `
  @import '../../../utils/styles/formGroup.scss';
  @import '../../../utils/styles/baseDialog.scss';
  `,
})
export class VersionControlAddComponent {
  frm = this._fb.group({
    versionCode: ['', Validators.required],
    versionName: ['', Validators.required],
    urlDownload: ['', [Validators.required, Validators.pattern(/^(http(s):\/\/.)[-a-zA-Z0-9@:%._~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_.~#?&//=]*)$/)]],
    required: [true, [Validators.required]],
    description: [''],
  });

  private loaderSrv = inject(LoaderService);
  private versionSrv = inject(VersionControlService)
  private versionDataSrv = inject(VersionControlDataService)
  private notifSrv = inject(NotificationService);

  loading = toSignal(this.loaderSrv.loaderState$)
  @ViewChild('firstInput') elementRef!: ElementRef<HTMLInputElement>

  constructor(
    public dialogRef: MatDialogRef<VersionControlAddComponent>,
    private _fb: NonNullableFormBuilder
  ) {
    this.dialogRef.afterOpened().subscribe(() => {
      setTimeout(() => {
        this.elementRef.nativeElement.focus()
      }, 50)
    })
  }

  onSubmit() {
    this.frm.markAllAsTouched()

    if(this.frm.valid){
      this.loaderSrv.show()
      const params = {
        ...this.frm.getRawValue(),
        packageName: this.versionDataSrv.getAppConfig().packageName,
      }
      this.versionSrv.createVersion(params)
      .pipe(
        finalize(() => {
          this.loaderSrv.hide();
        })
      )
      .subscribe({
        next: () => {
          this.notifSrv.dispatch('Versión creada', 'success');
          this.dialogRef.close(true);
        },
        error: (err: HttpErrorResponse) => {
          this.notifSrv.dispatch(err.error.message, 'error');
        },
      });
    }
  }

  get versionCode() {
    return this.frm.controls['versionCode'];
  }

  get versionName() {
    return this.frm.controls['versionName'];
  }

  get urlDownload() {
    return this.frm.controls['urlDownload'];
  }

  get required() {
    return this.frm.controls['required'];
  }

  get description() {
    return this.frm.controls['description'];
  }
}
